import { useEffect, useMemo } from 'react';
import { formatBytes } from './formatBytes';

/** Erlaubte Bildformate laut Vertrag 0.6 (GIF/WebP dürfen animiert sein). */
export const IMAGE_ACCEPT = 'image/png,image/jpeg,image/gif,image/webp';
const IMAGE_TYPES = IMAGE_ACCEPT.split(',');

/** Prüft Format und Größe; liefert eine deutsche Fehlermeldung oder null. */
export function checkImage(file: File, maxBytes: number): string | null {
  if (!IMAGE_TYPES.includes(file.type)) return 'Erlaubt sind PNG, JPEG, GIF und WebP.';
  if (maxBytes > 0 && file.size > maxBytes) return `Die Datei ist zu groß (höchstens ${formatBytes(maxBytes)}).`;
  return null;
}

/** Objekt-URL für eine lokale Datei (wird beim Wechsel/Unmount freigegeben). */
export function useObjectUrl(file: Blob | null): string | null {
  const url = useMemo(() => (file && typeof URL.createObjectURL === 'function' ? URL.createObjectURL(file) : null), [file]);
  useEffect(
    () => () => {
      if (url) URL.revokeObjectURL(url);
    },
    [url],
  );
  return url;
}
